import { CloseCircleOutlined } from '@ant-design/icons';
import useQuery from 'global/helperFunctions/useQuery';
import { FC, useEffect } from 'react';

const TcSearchMapResult: FC = () => {
  //hook
  const { query, search, setQuery } = useQuery();

  //effect
  useEffect(() => {}, [search]);

  const deleteSearchPhrase = () => {
    const { searchPhrase: _a, ...rest } = query;
    setQuery(rest);
  };

  return (
    <>
      {query?.searchPhrase && (
        <div className='flex items-center px-2 py-1 text-xs font-semibold shadow-md bg-t-bg-color text-t-text-color rounded-xl'>
          جستجوی شما: {query?.searchPhrase}
          <span className='pr-2 text-xs text-t-error-color color-inherit'>
            <CloseCircleOutlined onClick={deleteSearchPhrase} />
          </span>
        </div>
      )}
    </>
  );
};

export default TcSearchMapResult;
